import styled from 'styled-components';

import {
  Image,
} from 'semantic-ui-react';
import { Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: flex;
  height: 100%;
  padding-top: ${(props) => (props.showSideBar ? '80px' : '54px') };
  padding-right: ${(props) => (props.showSideBar ? '45px' : '0') };
  padding-bottom: ${(props) => (props.showSideBar ? '40px' : '0') };
  padding-left: ${(props) => (props.showSideBar ? '245px' : '0') };
`;

const Loader = styled(LoaderLayoutComponent).attrs(() => ({
  inline: false,
}))``;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 55px;
  justify-content: center;
  margin-bottom: 45px;
`;

const Logo = styled(Image)`
  &&& {
    display: inline;
    max-width: 150px;
  }
`;

export {
  Container,
  Loader,
  LogoContainer,
  Logo,
};
